const locations = [
  {
    locationName: 'PILAR',
    address: 'Office Park',
    mapUrl: 'https://maps.app.goo.gl/qqpVPALUWsdH14Zx5',
    phoneNumber: '+54 9 11 2689-4398'
  },
  {
    locationName: 'PILARÁ',
    address: 'Estación Pilará',
    mapUrl: 'https://maps.app.goo.gl/tiyUmw2py2m7Fegs6',
    phoneNumber: '+54 9 11 2650-9533'
  },
  {
    locationName: 'Nordelta',
    address: 'Av. del Puerto 955',
    mapUrl: 'https://maps.app.goo.gl/KMzyLXX7gCPC7Bqw8',
    phoneNumber: '+54 9 11 2519-0076'
  },
  {
    locationName: 'ESCOBAR',
    address: 'WorkClub',
    mapUrl: 'https://maps.app.goo.gl/zfEAiiW8xAr2nRve6',
    phoneNumber: '+54 9 11 3336-6571'
  },
  {
    locationName: 'Palermo Soho',
    address: 'Fray Justo Sta. María de Oro 2150, CABA',
    mapUrl: 'https://maps.app.goo.gl/TtK218sy38U6P52Y6',
    phoneNumber: '+54 9 11 5457-3847'
  },
  {
    locationName: 'Palermo Hollywood',
    address: 'Av. Dorrego 1789',
    mapUrl: 'https://maps.app.goo.gl/xzvAYTnRhuE386Gs6',
    phoneNumber: '+54 9 11 3284-9318'
  },
  {
    locationName: 'Belgrano C',
    address: 'Av. del Libertador 5990',
    mapUrl: 'https://maps.app.goo.gl/7HZH6oE9Yq4v81oS6',
    phoneNumber: '+54 9 11 6657-8230'
  }
];

export default locations;
